import { StepShell, SectionGroup } from '../components/layout';
import { TextArea } from '../components/inputs';
import { ChoiceCards } from '../components/selection';

/** Follow-up questions only appear for people who have something to say. */
const HAS_BUILT = ['built_sold', 'built', 'tried'];

export default function BuilderMindsetStep({ data, update, notes = {}, config }) {
  const status = data.status;
  const showDetails = HAS_BUILT.includes(status);

  return (
    <StepShell
      eyebrow="Step 13 of 18"
      title="Have you ever built something of your own?"
      lede="A side project, a small business, a shop on Instagram, an app nobody used. Anything you started because you wanted to, not because you were told to."
      why="People who have tried to make something on their own tend to approach problems differently. It is not a requirement — we are just curious."
      encouragement="“I have not, and it is not really my thing” is a completely respectable answer. Plenty of excellent people say exactly that."
    >
      <ChoiceCards
        options={config.builderStatus}
        value={status}
        note={notes.status}
        onChange={(v) => update({ status: v, skipped: false })}
      />

      {showDetails && (
        <SectionGroup label="Tell us about it">
          <TextArea
            id="builder_details"
            label="What was it?"
            rows={4}
            maxLength={1500}
            placeholder="What you made, who it was for, how far you got."
            value={data.details}
            note={notes.details}
            onChange={(v) => update({ details: v })}
          />

          <TextArea
            id="builder_learned"
            label="What did you take away from it?"
            optional
            rows={3}
            maxLength={600}
            placeholder="Especially if it did not work out — that is usually where the interesting part is."
            value={data.learned}
            note={notes.learned}
            onChange={(v) => update({ learned: v })}
          />
        </SectionGroup>
      )}
    </StepShell>
  );
}
